module.exports = __webpack_public_path__ + "img/Produktbeispiel_3.3b048ef8.jpg";